jQuery(document).ready(function($){
    function mapAutocompleteFinderInit() {
        var input = document.getElementById('product-finder__location-input');
        var autocomplete = new google.maps.places.Autocomplete(input);
        autocomplete.setComponentRestrictions({
            country: ['AU'],
        });
        autocomplete.setTypes(["(regions)"]);

        google.maps.event.addListener(autocomplete, 'place_changed', function() {
            var place = autocomplete.getPlace();
            var lat = place.geometry.location.lat();
            var lng = place.geometry.location.lng();
            var url = jQuery('#product-finder__location-hidden').data('url');

            jQuery('#product-finder__location-hidden').val(place.formatted_address);

            var data = {
                'action'    : 'get_stores',
                'lat'       : lat,
                'lng'       : lng,
                'radius'    : 50,
                'limit'     : 5
            };

            jQuery('.product-finder__btn').html( jQuery('.product-finder__btn').data('loading') );
            jQuery('.product-finder__icon').removeClass('active');
            jQuery('.product-finder__loading').addClass('active');
            jQuery.post(url, data, function(response) {
                var stores = JSON.parse(response);
                jQuery('.product-finder__loading').removeClass('active');
                if( jQuery.isEmptyObject( stores ) ){
                    jQuery('.product-finder__results').append(
                        '<div class="product-finder__store">' +
                            '<div class="product-finder__store-address">Sorry we couldn\'t find any stores near you</div>' +
                        '</div>'
                    );
                    jQuery('.product-finder__form').removeClass('active');
                }else{
                    for (var key of Object.keys(stores)) {
                        if(key < 2){
                            jQuery('.product-finder__results').append(
                                '<div class="product-finder__store">' +
                                    '<div class="product-finder__store-title">' +
                                        '<svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.22922 19.5965C1.55352 11.3684 0.500001 10.5239 0.500001 7.5C0.5 3.35785 3.85785 -2.93553e-07 8 -6.55671e-07C12.1421 -1.01779e-06 15.5 3.35785 15.5 7.5C15.5 10.5239 14.4465 11.3684 8.77078 19.5965C8.39832 20.1345 7.60164 20.1345 7.22922 19.5965ZM8 10.625C9.7259 10.625 11.125 9.2259 11.125 7.5C11.125 5.7741 9.7259 4.375 8 4.375C6.2741 4.375 4.875 5.7741 4.875 7.5C4.875 9.2259 6.2741 10.625 8 10.625Z" fill="#e85c28"/></svg>' +
                                        '<span>' + stores[key].na + '</span>' +
                                    '</div>' +
                                    '<div class="product-finder__store-address">' + stores[key].st + ', ' + stores[key].rg + ' ' + stores[key].zp + '</div>' +
                                    '<div class="product-finder__store-phone"><a href="tel:' + stores[key].te + '">' + stores[key].te + '</a></div>' +
                                    '<div class="product-finder__store-direction"><a target="_blank" href="https://www.google.com/maps?daddr=' + stores[key].st + ', ' + stores[key].rg + ' ' + stores[key].zp + '"><span>Get Direction</span>' +
                                        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.8333 13.8333H2.16667V2.16667H8V0.5H2.16667C1.24167 0.5 0.5 1.25 0.5 2.16667V13.8333C0.5 14.75 1.24167 15.5 2.16667 15.5H13.8333C14.75 15.5 15.5 14.75 15.5 13.8333V8H13.8333V13.8333ZM9.66667 0.5V2.16667H12.6583L4.46667 10.3583L5.64167 11.5333L13.8333 3.34167V6.33333H15.5V0.5H9.66667Z" fill="#e85c28"/></svg>' +
                                    '</a></div>' +
                                '</div>'
                            );
                        }
                    }
                    jQuery('.product-finder__form').addClass('active');
                }

                jQuery('.product-finder__clear').addClass('active');
                jQuery('.product-finder__btn').html( jQuery('.product-finder__btn').data('text') );
            });
        });
    }

    google.maps.event.addDomListener(window, 'load', mapAutocompleteFinderInit);

    jQuery(document).on('click', '.product-finder__clear', function(){
        jQuery(this).removeClass('active');
        jQuery('#product-finder__location-hidden').val('');
        jQuery('#product-finder__location-input').val('');
        jQuery('.product-finder__results').html('');
        jQuery('.product-finder__form').removeClass('active');
        jQuery('.product-finder__icon').addClass('active');
    });
});